import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../context/GlobalContext';
import { useNotificationService } from '../../services/notification.service';
import { useAcaFeedbackService } from '../../services/aca-feedback';
import {
  IAcaAulaDTO,
  IFeedbackCleanDTO,
} from '../../models/happy-code-api.model';
import { TFunction } from 'i18next';

interface useModalClassificacaoProps {
  feedback: IFeedbackCleanDTO;
  proximaAula: IAcaAulaDTO;
  onClose: () => void;
  t: TFunction<"trilhas", undefined>
}

export default function useModalClassificacao({
  feedback,
  proximaAula,
  onClose,
  t
}: useModalClassificacaoProps) {
  const { setIsGlobalLoading } = useGlobalContext();
  const notification = useNotificationService();
  const navigate = useNavigate();
  const feedbackService = useAcaFeedbackService();

  const saveFeedback = () => {
    setIsGlobalLoading(true);

    feedbackService
      .create(feedback)
      .then(() => {
        navigate(-1);

        notification({
          description: t('trilhas:notifications.feedbackSaved'),
          type: 'success',
          message: t('common:success'),
        });
      })
      .catch(() =>
        notification({
          description: t('trilhas:notifications.feedbackNotSaved'),
          type: 'error',
          message: t('common:caution'),
        }),
      )
      .finally(() => setIsGlobalLoading(false));

    onClose();
  };

  return {
    saveFeedback,
  };
}
